import { FETCH_RATES_BY_ORDER_SUCCESS, FETCH_RATES_BY_ORDER_REQUEST, FETCH_RATES_BY_ORDER_FAILURE, } from "../../actions";
const initialState = {
    carrierRates: null,
    isLoading: false,
    error: null,
};
const RateByOrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_RATES_BY_ORDER_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, carrierRates: null });
        case FETCH_RATES_BY_ORDER_SUCCESS:
            return Object.assign(Object.assign({}, state), { carrierRates: action.payload, isLoading: false, error: null });
        case FETCH_RATES_BY_ORDER_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        default:
            return state;
    }
};
export default RateByOrderReducer;
